"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var ActionButton_1 = __importDefault(require("stremio/components/MetaPreview/ActionButton"));
var Actions_less_1 = __importDefault(require("./Actions.less"));
var Actions = function (_a) {
    var children = _a.children, inLibrary = _a.inLibrary, onToggleLibrary = _a.onToggleLibrary;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: Actions_less_1.default['actions'] },
        children,
        react_1.default.createElement(ActionButton_1.default, { className: Actions_less_1.default['action-button'], icon: inLibrary ? 'remove-from-library' : 'add-to-library', label: inLibrary ? t('REMOVE_FROM_LIB') : t('ADD_TO_LIB'), variant: 'icon', tooltip: true, role: 'button', onClick: onToggleLibrary })));
};
exports.default = Actions;
